import type { ActivityModule } from '../../core/activity';
import { mountGnumchMultiples } from './ui';
import levelsData from './levels.json';
import '../gnumch-equality/style.css';

export const gnumchMultiples: ActivityModule = {
  id: 'gnumch-multiples',
  title: 'Comilão de múltiplos',
  description: 'Coma só os múltiplos do número alvo (o resultado da multiplicação por inteiros). Cuidado com os fantasmas!',
  ageMin: 8,
  ageMax: 12,
  difficulty: 5,
  iconPath: 'assets/gcompris-AGPL/gnumch-multiples/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountGnumchMultiples,
};
